<template>
    <div class="surface-card p-4 shadow-2 border-round text-center">
        <div class="text-lg font-bold my-3">Before begining an assessment you must select a "User" first !</div>
        <Divider />
        <div class="mb-3">
            <div class="flex justify-content-center">
                <UsersPicker @user-selected="userSelected" />
            </div>
        </div>
        <div v-if="user" class="border-3 border-dashed surface-border mx-auto">
            <div class="text-xl">
                <span class="text-orange-500 capitalize font-bold">{{ user.fullname }}</span>
            </div>
        </div>

        <div v-if="!withUserProfile && user" class="text-orange-500 font-bold mt-3">
            The selected user does not have a User Profile.<br />
            Please create one before attempting an assessment<br />
            <br />

            <router-link :to="'/form/user_profile/'+user.id">
                <Button label="Edit User Assessment" icon="pi pi-arrow-circle-right"></Button>
            </router-link>
        </div>
    </div>
    <br />
    <div class="surface-card p-4 shadow-2 border-round text-center">
        <div class="text-lg font-bold my-3">Now select an assessment you would like to proceed with !</div>
        <Divider />
        <div class="mb-3">
            <Dropdown v-model="assessment" :options="assessmentStore.assessments" filter optionLabel="name" placeholder="Select an assessment" class="w-full md:w-14rem">
                <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center">
                        <div>{{ slotProps.value.name }}</div>
                    </div>
                    <span v-else>{{ slotProps.placeholder }}</span>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center">
                        <div>{{ slotProps.option.name }}</div>
                    </div>
                </template>
            </Dropdown>
        </div>
        <div v-if="assessment" class="border-3 border-dashed surface-border mx-auto">
            <div class="text-xl">
                <span class="text-orange-500 font-bold">{{ assessment.name }}</span>
            </div>
        </div>
    </div>
    <br />
    <div class="text-center">
        <Button label="Start Assessment" icon="pi pi-book" class="font-bold px-5 py-3 p-button-raised p-button-rounded white-space-nowrap" @click="startAssessment" :disabled="startDisabled"></Button>
    </div>
</template>

<script setup>
import UsersPicker from '@/components/user/UsersPicker';

import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAssessmentStore } from '../../assessment/store';

const router = useRouter();
const assessmentStore = useAssessmentStore();

const user = ref(null);
const assessment = ref(null);

const withUserProfile = ref(false)

const startDisabled = computed(() => {
    if (assessment.value !== null && assessment.value.id && assessment.value.id > 0) {
        if (user.value !== null && user.value.id > 0 && user.value.withUserProfile) {
            return false
        }
    }

    return true
});

onMounted(async () => {
    await assessmentStore.fetchAllAssessments();
});

const startAssessment = () => {
    router.push({ name: 'AnswerAssessment', params: { userId: parseInt(user.value?.id), assessmentCode: assessment.value?.code } });
};

const userSelected = (userDetails) => {
    //console.log('userDetails', userDetails)

    withUserProfile.value = userDetails.withUserProfile;

    user.value = userDetails;
};
</script>
